export function generatePublicAccessToken(): string {
    if (typeof globalThis.crypto?.randomUUID === 'function') {
        return globalThis.crypto.randomUUID().replace(/-/g, '');
    }

    const alphabet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    const randomValues = typeof globalThis.crypto?.getRandomValues === 'function'
        ? globalThis.crypto.getRandomValues(new Uint8Array(32))
        : Array.from({ length: 32 }, () => Math.floor(Math.random() * alphabet.length));

    return Array.from(randomValues, (value) => alphabet[Number(value) % alphabet.length]).join('');
}
